// Меню поверх экрана до 900 px (README «Каркас экрана»: «меню выезжает поверх экрана и
// закрывается при переходе»): панель слева с затемнением, Tab внутри, Esc и клик по затемнению
// закрывают, фокус возвращается на кнопку «Открыть меню». 044: меню уходит за левый край
// (t-side-out «Табеля», 240 мс), затемнение гаснет вместе с ним; фокус — в начале выхода.
import * as Dialog from '@radix-ui/react-dialog';
import { useRef } from 'react';
import type { ReactNode } from 'react';
import { cx } from '../lib/cx.ts';
import { keepOpenForToasts, relayEscape } from '../lib/layers.ts';
import { useReturnFocus } from '../lib/return-focus.ts';
import { ToastLayerRegion } from '../lib/toast-layer.tsx';

export interface SideSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Имя панели для программ чтения экрана: «Меню». */
  title: string;
  children: ReactNode;
  className?: string;
}

export function SideSheet({ open, onOpenChange, title, children, className }: SideSheetProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const returnFocus = useReturnFocus(open, contentRef);
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="kp-sheet-scrim" />
        <Dialog.Content
          ref={contentRef}
          className={cx('kp-side-sheet', className)}
          aria-describedby={undefined}
          onCloseAutoFocus={returnFocus}
          // Esc, пока меню уходит, — следующему слою (044, MOT-07).
          onEscapeKeyDown={(event) => {
            if (open) return;
            event.preventDefault();
            relayEscape(contentRef.current, event);
          }}
          onPointerDownOutside={keepOpenForToasts}
          onInteractOutside={keepOpenForToasts}
        >
          <Dialog.Title className="kp-sr-only">{title}</Dialog.Title>
          {children}
          <ToastLayerRegion active={open} />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
